module.exports = __webpack_public_path__ + "img/icon_06.f0e0d710.png";